var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.73208V17.6487M11 5.73208C9.92933 5.02075 8.4755 4.5835 6.875 4.5835C5.2745 4.5835 3.82067 5.02075 2.75 5.73208V17.6487C3.82067 16.9374 5.2745 16.5002 6.875 16.5002C8.4755 16.5002 9.92933 16.9374 11 17.6487M11 5.73208C12.0707 5.02075 13.5245 4.5835 15.125 4.5835C16.7264 4.5835 18.1793 5.02075 19.25 5.73208V17.6487C18.1793 16.9374 16.7264 16.5002 15.125 16.5002C13.5245 16.5002 12.0707 16.9374 11 17.6487",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.2747017679ec97175f0caae998f984b5.svg";
export { ForwardRef as ReactComponent };